import { CryptotokenKey } from 'src/app/shared/entities/cryptotoken-key';

export interface CryptotokenKeyDto {
  alias: string | null | undefined;
  keyAlgorithm: string | null | undefined;
  keySpecification: string | null | undefined;
  subjectKeyID: string | null | undefined;
  createdTime: number | null | undefined;
  updateTime: number | null | undefined;
}

export function cryptotokenKeyDtoToCryptotokenKey(
  tokenName: string,
  dto: CryptotokenKeyDto,
): CryptotokenKey {
  return {
    tokenName,
    details: {
      alias: dto.alias ?? '',
      keyAlgorithm: dto.keyAlgorithm ?? '',
      keySpecification: dto.keySpecification ?? '',
      subjectKeyID: dto.subjectKeyID ?? '',
      createdTime: new Date(dto.createdTime ?? ''),
      updateTime: new Date(dto.updateTime ?? ''),
    },
  };
}
